import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";
import { tableCellClasses } from "@mui/material/TableCell";

type MuiTableCellOverrides = {
  defaultProps?: ComponentsProps['MuiTableCell'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTableCell'];
  variants?: ComponentsVariants['MuiTableCell'];
}

function getMuiTableCellOverride(): MuiTableCellOverrides {
  return {
    styleOverrides: {
      root: {
        fontSize: "1.4rem",
        [`&.${tableCellClasses.head}`]: {
          paddingInline: "var(--table-head-padding-inline)",
          paddingBlock: "var(--table-head-padding-block)",
          borderBottom: "var(--table-head-bdr-width) solid var(--table-head-bdr-clr)",
        },
        [`&.${tableCellClasses.body}`]: {
          paddingInline: "var(--table-cell-padding-inline)",
          paddingBlock: "var(--table-cell-padding-block)",
          borderBottom: "var(--table-cell-bdr-width) solid var(--table-cell-bdr-clr)",
        }
      }
    }
  }
}

export default getMuiTableCellOverride;